import { neoauth } from "./api";

export const CLIENT_ID = import.meta.env.VITE_API_CLIENT_ID;

const appUrl =
  import.meta.env.VITE_ENV === "local"
    ? import.meta.env.VITE_URL
    : `${window.location.protocol}//${window.location.hostname}/`;

export const APP_ROUTES = {
  authorizeUrl: `${neoauth}o/authorize/`,
  revokeToken: `${neoauth}o/revoke_token/`,
  redirectUri: appUrl,
  page404: `${appUrl}404`,
  page500: `${appUrl}500`,
  page401: `${appUrl}application/dashboard`,
  pageError: `${appUrl}error`,
  fullLoginUrl: "",
  appUrl: `${appUrl}`,
};

APP_ROUTES.fullLoginUrl = `${APP_ROUTES.authorizeUrl}?response_type=token&client_id=${
  CLIENT_ID
}&scope=read&redirect_uri=${APP_ROUTES.redirectUri}${window.location.pathname.substring(
  1,
)}${encodeURIComponent(window.location.search)}`;
